// @flow

import React, { Fragment } from 'react'
import renderUIError from 'helper/renderUIError'

export default ({
  ui,
  company,
  onChangeCompany,
}: {
  ui: {
    errors: Array<{
      field: string,
      message: string,
    }>,
  },
  company: {
    contactPersonFamilyName: string,
    contactPersonGivenName: string,
    contactPersonFamilyNameKana: string,
    contactPersonGivenNameKana: string,
    department: string,
    email: string,
  },
  onChangeCompany: Function,
}) => (
  <Fragment>
    <h2 className="business-setting-title">担当者情報</h2>
    <li className="business-reservation-setting__line">
      <p className="business-reservation-setting__heading">
        <span className="icon-form icon-form__required">必須</span>担当者氏名
      </p>
      <input
        type="text"
        value={company.contactPersonFamilyName || ''}
        onChange={e =>
          onChangeCompany('contactPersonFamilyName', e.target.value)
        }
        className={`business-reservation-setting__form business__form business__form-name mr20 ${
          renderUIError.hasError('contactPersonFamilyName', ui.errors)
            ? 'form-error'
            : ''
        }`}
        placeholder="姓"
      />
      <input
        type="text"
        value={company.contactPersonGivenName || ''}
        onChange={e =>
          onChangeCompany('contactPersonGivenName', e.target.value)
        }
        className={`business-reservation-setting__form business__form business__form-name ${
          renderUIError.hasError('contactPersonGivenName', ui.errors)
            ? 'form-error'
            : ''
        }`}
        placeholder="名"
      />
      {renderUIError.settingError('contactPersonFamilyName', ui.errors)}
      {renderUIError.settingError('contactPersonGivenName', ui.errors)}
    </li>
    <li className="business-reservation-setting__line">
      <p className="business-reservation-setting__heading">
        <span className="icon-form icon-form__required">必須</span>
        担当者氏名カナ
      </p>
      <input
        type="text"
        value={company.contactPersonFamilyNameKana || ''}
        onChange={e =>
          onChangeCompany('contactPersonFamilyNameKana', e.target.value)
        }
        className={`business-reservation-setting__form business__form business__form-name mr20 ${
          renderUIError.hasError('contactPersonFamilyNameKana', ui.errors)
            ? 'form-error'
            : ''
        }`}
        placeholder="セイ（カナ）"
      />
      <input
        type="text"
        value={company.contactPersonGivenNameKana || ''}
        onChange={e =>
          onChangeCompany('contactPersonGivenNameKana', e.target.value)
        }
        className={`business-reservation-setting__form business__form business__form-name ${
          renderUIError.hasError('contactPersonGivenNameKana', ui.errors)
            ? 'form-error'
            : ''
        }`}
        placeholder="メイ（カナ）"
      />
      {renderUIError.settingError('contactPersonFamilyNameKana', ui.errors)}
      {renderUIError.settingError('contactPersonGivenNameKana', ui.errors)}
    </li>
    <li className="business-reservation-setting__line">
      <p className="business-reservation-setting__heading">
        <span className="icon-form icon-form__optional">任意</span>部署名
      </p>
      <input
        type="text"
        value={company.department || ''}
        onChange={e => onChangeCompany('department', e.target.value)}
        className="business-reservation-setting__form business__form"
        placeholder="プロダクト開発部"
      />
    </li>
    <li className="business-reservation-setting__line">
      <p className="business-reservation-setting__heading">
        <span className="icon-form icon-form__required">必須</span>
        メールアドレス
      </p>
      <input
        type="text"
        value={company.email || ''}
        onChange={e => onChangeCompany('email', e.target.value)}
        className={`business-reservation-setting__form business__form ${
          renderUIError.hasError('email', ui.errors) ? 'form-error' : ''
        }`}
        placeholder="supesuma@spacemarket.co.jp"
      />
      <p className="business-reservation-setting__about-mail">
        Paidから審査結果や請求書情報が送られます。
      </p>
      {renderUIError.settingError('email', ui.errors)}
    </li>
  </Fragment>
)
